"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _components = require("@engaging-tech/components");

var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));

var _AnimatedStarIcon = _interopRequireDefault(require("../desktop/AnimatedStarIcon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = {
  container: {
    position: "relative",
    width: "100%"
  },
  userButton: function userButton(bgColor) {
    return {
      display: "flex",
      alignItems: "center",
      backgroundColor: bgColor,
      borderRadius: 99,
      height: 34,
      padding: "4px 8px",
      margin: 4,
      userSelect: "none",
      border: "none",
      cursor: "pointer"
    };
  },
  userNameText: {
    color: "#333",
    fontSize: 14,
    margin: "0 8px"
  },
  menuContainer: {
    width: "calc(100% + 8px)",
    marginLeft: -8,
    marginRight: -8,
    backgroundColor: "#fff"
  },
  menuButtonBase: {
    textAlign: "left",
    width: "100%",
    padding: "12px 24px",
    cursor: "pointer",
    userSelect: "none",
    border: "none",
    display: "block",
    backgroundColor: "#fff"
  }
};

function MenuItemList(_ref) {
  var items = _ref.items,
      _ref$hoverColor = _ref.hoverColor,
      hoverColor = _ref$hoverColor === void 0 ? "#e0f5f5" : _ref$hoverColor;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      key: item.label,
      onClick: function onClick() {
        window.location.href = item.href;
      },
      style: styles.menuButtonBase,
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.backgroundColor = hoverColor;
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.backgroundColor = "#fff";
      }
    }, item.label);
  }));
}

function NavUserDetails() {
  var _userDetails$details, _userDetails$details2, _userDetails$details3, _userDetails$details4, _userDetails$details5;

  var _useNavContext = (0, _useNavContext2["default"])(),
      userDetails = _useNavContext.userDetails,
      holdingImage = _useNavContext.holdingImage;

  var _useState = (0, _react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  if (!(userDetails !== null && userDetails !== void 0 && userDetails.isAuthenticated)) return null;
  var name = ((_userDetails$details = userDetails.details) === null || _userDetails$details === void 0 ? void 0 : _userDetails$details.firstName) || "User";
  var isPremium = (_userDetails$details2 = userDetails.details) === null || _userDetails$details2 === void 0 ? void 0 : (_userDetails$details3 = _userDetails$details2.premium) === null || _userDetails$details3 === void 0 ? void 0 : _userDetails$details3.active;
  var bgColor = isPremium ? userDetails.premiumColor || "primary.1" : userDetails.nonPremiumColor || "dark.2";
  var menuItems = [{
    label: "My Profile",
    href: "/profile/" + (userDetails === null || userDetails === void 0 ? void 0 : userDetails.id)
  }, {
    label: "My Posts",
    href: "/settings/my-posts"
  }, {
    label: "My Contacts",
    href: "/settings/contacts"
  }, {
    label: "My Library",
    href: "/settings/library"
  }, {
    label: "Global Hub Preferences",
    href: "/settings/global-hub-preferences"
  }, {
    label: "Privacy Settings",
    href: "/settings/privacy"
  }, {
    label: "Account Settings",
    href: "/settings/account"
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setIsOpen(function (prev) {
        return !prev;
      });
    },
    style: styles.userButton(bgColor)
  }, isPremium && /*#__PURE__*/_react["default"].createElement(_AnimatedStarIcon["default"], {
    color: "dark.3"
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    style: styles.userNameText
  }, name), /*#__PURE__*/_react["default"].createElement(_components.Avatar, {
    picture: ((_userDetails$details4 = userDetails.details) === null || _userDetails$details4 === void 0 ? void 0 : (_userDetails$details5 = _userDetails$details4.picture) === null || _userDetails$details5 === void 0 ? void 0 : _userDetails$details5.small) || holdingImage || null,
    size: 24,
    style: {
      marginLeft: 4
    }
  })), isOpen && /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.menuContainer
  }, /*#__PURE__*/_react["default"].createElement(MenuItemList, {
    items: menuItems
  })));
}

var _default = NavUserDetails;
exports["default"] = _default;